export default __webpack_public_path__ + "static/media/logotransparent.60a54e7b.png";